import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { getCropTypes, getField, updateField } from "api/Field";
import { MapActions, MapContext } from "context/map";
import { UserContext } from "context/user";
import CustomModal from "components/Modal";
import Button from "components/Button";
import "./index.scss";

const SelectCropTypes = ({ isOpen, onClose }) => {
  const { token } = useContext(UserContext);
  const { state, dispatch } = useContext(MapContext);
  const { selectedFields } = state;
  const [cropTypes, setCropTypes] = useState([]);
  const [selectedCropTypes, setSelectedCropTypes] = useState("");

  useEffect(() => {
    const fetchCropTypes = async () => {
      const cropTypesData = await getCropTypes(token);
      setCropTypes(cropTypesData);
    };

    if (!cropTypes.length) {
      fetchCropTypes();
    }
  }, [cropTypes, token]);

  const handleUpdateCropType = async () => {
    if (!selectedFields[0]) return;
    const id = selectedFields[0];
    const fieldInfo = await getField(id, token);
    try {
      if (!fieldInfo) return;
      const updatedFieldInfo = {
        bbox: fieldInfo.bbox,
        geometry: fieldInfo.geometry,
        properties: {
          area: fieldInfo.properties.area,
          farm_id: fieldInfo.properties.farm_id,
          field_crop_type: selectedCropTypes,
          field_name: fieldInfo.properties.field_name,
          id: fieldInfo.properties.id,
          permission: fieldInfo.properties.permission,
        },
        type: fieldInfo.type,
      };
      const updatedField = await updateField(id, updatedFieldInfo, token);
      dispatch({
        type: MapActions.SAVE_EDIT_FIELD,
        value: { field: updatedField, switch: true },
      });
      toast.success("Field crop type updated successfully!");
      onClose();
    } catch {
      toast.error("Can't update field");
    }
  };

  const renderCropTypes = () => {
    return cropTypes?.map((crop) => (
      <option key={crop} value={crop}>
        {crop}
      </option>
    ));
  };

  const handleOnClose = () => {
    onClose();
  };

  const handleSelectCropType = (event) => {
    setSelectedCropTypes(event.target.value);
  };

  return (
    <CustomModal
      isOpen={isOpen}
      size="medium"
      onClose={handleOnClose}
      onRequestClose={handleOnClose}
    >
      <div className="select-crops" data-testid="select-crops-content">
        <h3 className="title">Crops Missing!</h3>
        <div className="paragraph">
          In order for us to show you precise imagery, we need you to provide us
          the crop type for your field.
        </div>

        <div className="input-field">
          <select
            name="crop-types"
            className="input"
            onChange={(e) => handleSelectCropType(e)}
          >
            <option value="" selected>
              Select Crop Type
            </option>
            {renderCropTypes()}
          </select>
          <p className="label">Select Crop Type</p>
        </div>
        <Button
          id="update-button"
          type="solid"
          color="green"
          label="Update Crop Type"
          block
          onClick={handleUpdateCropType}
        />
      </div>
    </CustomModal>
  );
};

SelectCropTypes.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SelectCropTypes;
